import { apiClient } from './client';

// round10 요구1 — 고객사 CRM 접촉 메모 타임라인 api client.
// 백엔드: GET /customers/:id/notes · POST /customers/:id/notes ·
// PATCH /customer-notes/:noteId · DELETE /customer-notes/:noteId.

export interface CustomerNote {
  id: string;
  body: string;
  createdAt: string;
  updatedAt: string | null; // null = 한 번도 수정 안 됨 → '수정됨' 배지 숨김
  authorUserId: string | null;
  authorName: string | null; // 작성자 삭제 시 null → UI '(삭제된 사용자)' 폴백
}

export const customerNotesApi = {
  async list(customerId: string): Promise<CustomerNote[]> {
    const { data } = await apiClient.get<CustomerNote[]>(`/customers/${customerId}/notes`);
    return data;
  },
  async create(customerId: string, body: string): Promise<CustomerNote> {
    const { data } = await apiClient.post<CustomerNote>(`/customers/${customerId}/notes`, { body });
    return data;
  },
  async update(noteId: string, body: string): Promise<CustomerNote> {
    const { data } = await apiClient.patch<CustomerNote>(`/customer-notes/${noteId}`, { body });
    return data;
  },
  async remove(noteId: string): Promise<{ deleted: boolean }> {
    const { data } = await apiClient.delete<{ deleted: boolean }>(`/customer-notes/${noteId}`);
    return data;
  },
};
